
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/testanalytics",
      function () {
        return require("private-next-pages/testanalytics/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/testanalytics"])
      });
    }
  